import { Particle, Vector2 } from './types'

export class ParticleSystem {
  private particles: Particle[] = []

  createExplosion(position: Vector2, color: string, count: number = 10) {
    for (let i = 0; i < count; i++) {
      const angle = (Math.PI * 2 * i) / count
      const speed = 2 + Math.random() * 3

      this.particles.push({
        position: { ...position },
        velocity: {
          x: Math.cos(angle) * speed,
          y: Math.sin(angle) * speed,
        },
        life: 1,
        maxLife: 1,
        color,
        size: 3 + Math.random() * 3,
      })
    }
  }

  createTrail(position: Vector2, color: string) {
    this.particles.push({
      position: { ...position },
      velocity: { x: 0, y: 0.5 },
      life: 0.5,
      maxLife: 0.5,
      color,
      size: 4,
    })
  }

  update(deltaTime: number) {
    this.particles = this.particles.filter((p) => {
      p.life -= deltaTime
      p.position.x += p.velocity.x
      p.position.y += p.velocity.y
      p.velocity.y += 0.2 // Gravity
      return p.life > 0
    })
  }

  render(ctx: CanvasRenderingContext2D) {
    this.particles.forEach((p) => {
      const alpha = p.life / p.maxLife
      ctx.fillStyle = p.color.replace(')', `, ${alpha})`).replace('rgb', 'rgba')
      ctx.fillRect(
        p.position.x - p.size / 2,
        p.position.y - p.size / 2,
        p.size,
        p.size,
      )
    })
  }

  clear() {
    this.particles = []
  }
}
